import {MOCK_REVIEW_DATA} from "src/app/mock/MockReviewData";
import {MOCK_REVIEW_LIST} from "src/app/mock/MockReviewList";
import {GetReviewResponse} from "src/app/api/model/response/GetReviewResponse";
import {ListReviewResponse} from "src/app/api/model/response/ListReviewResponse";
import {ExportReviewResponse} from "src/app/api/model/response/ExportReviewResponse";
import {UpdateReviewResponse} from "src/app/api/model/response/UpdateReviewResponse";

export const MOCK_GET_REVIEW_SUCCESS_RESPONSE: GetReviewResponse = {
    data: MOCK_REVIEW_DATA,
    msg: "get Review successfully",
    result: "success"
};

export const MOCK_GET_REVIEW_FAILED_RESPONSE = {
    data: {},
    msg: "get Review failed",
    result: "error"
}


export const MOCK_LIST_REVIEW_SUCCESS_RESPONSE: ListReviewResponse = {
    data: {
        list: MOCK_REVIEW_LIST
    },
    msg: "list Review successfully",
    result: "success"
}

export const MOCK_LIST_REVIEW_FAILED_RESPONSE = {
    data: {},
    msg: "list Review failed",
    result: "error"
}

export const MOCK_EXPORT_REVIEW_SUCCESS_RESPONSE: ExportReviewResponse = {
    data: {
        link: "https://api.eep.fd93c3ee-2ef2-4cc7-9675-52264bae8133",
        fileName: "file.csv"
    },
    msg: "export Review successfully",
    result: "success"
}

export const MOCK_EXPORT_REVIEW_FAILED_RESPONSE = {
    data: {},
    msg: "export Review failed",
    result: "error"
}

export const MOCK_UPDATE_REVIEW_FAILED_RESPONSE = {
    data: {},
    msg: "update Review failed",
    result: "error"
}

export const MOCK_UPDATE_REVIEW_SUCCESS_RESPONSE: UpdateReviewResponse = {
    data: {},
    msg: "update Review successfully",
    result: "success"
}